var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"clearfix mb-0"},[_c('span',{staticClass:"float-md-left d-none d-md-block"},[_vm._v(" Copyright © "+_vm._s(_vm.currentYear)+" IT DBC ")])])}
var staticRenderFns = []

export { render, staticRenderFns }